<template>
    <el-backtop target=".main-wrapper .main-scroll" 
      style="background-color:#0089D0;color: #fff;" 
      :visibility-height="50" 
      :bottom="118">
    </el-backtop>
</template>
<script>
export default {
    name: 'bottom-backtop'
}
</script>